<template>
  <div class="container">
    <div class="main">
      <p class="tips red" v-if="noIP">{{ noIP }}</p>
      <!-- <p class="tips" v-else><i class="el-icon-warning"></i>账号：{{ name }}，密码：{{ pwd }}</p> -->

      <h3>{{ titlename }}</h3>
      <div class="tab">
        <ul>
          <li @click="handleChangeTab(1)" :class="{ checked: tabIndex == 1 }">账号登录</li>
          <li @click="handleChangeTab(2)" :class="{ checked: tabIndex == 2 }" v-if="tab2">统一认证登录</li>
        </ul>
      </div>
      <div class="loginForm" v-if="tabIndex == 1">
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" class="demo-ruleForm">
          <el-form-item prop="username">
            <div class="inputDiv">
              <img src="@/assets/images/user.png" />
              <el-input type="name" v-model="ruleForm.username" clearable placeholder="请输入用户名"> </el-input>
            </div>
          </el-form-item>
          <el-form-item prop="password">
            <div class="inputDiv">
              <img src="@/assets/images/password.png" />
              <el-input type="password" clearable v-model="ruleForm.password" placeholder="请输入密码" @keyup.enter.native="submitForm('ruleForm')"></el-input>
            </div>
          </el-form-item>
          <p class="ipTips red" v-if="ipUser"><i class="el-icon-warning"></i>您现在是IP用户,请使用真实账号密码重新登录</p>
          <!-- <p class="ipTips red" v-if="noipUser">
            <i class="el-icon-warning"></i>您当前不在学校IP范围内不可注册
          </p> -->
          <el-form-item class="btn">
            <el-button type="primary" @click="submitForm('ruleForm')">登录</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="tab2-form loginForm" v-if="tabIndex == 2">
        <div>
          <el-select v-model="schoolCode" placeholder="请选择学校">
            <el-option v-for="item in schoolList" :key="item.code" :label="item.name" :value="item.code"> </el-option>
          </el-select>
        </div>

        <div class="tab2-btn">
          <el-button type="primary" @click="toCaseLogin">登录</el-button>
        </div>
      </div>
      <div class="userbtn">
        <div class="register">没有账号,去<span @click="toregister">注册</span></div>
        <div class="pwd">忘记密码,去<span @click="topwd">找回</span></div>
      </div>
    </div>
    <p class="login-bottom">版权所有 江苏畅想之星信息技术有限公司</p>
  </div>
</template>

<script>
import axios from "axios";
import urlSet from "@/api/baseurl.js";
export default {
  data() {
    return {
      tabIndex: 1,
      noIP: "", //有值 不在ip范围内，否则 在ip范围内
      ruleForm: {
        username: "",
        password: "",
      },
      name: "",
      pwd: "",
      rules: {
        username: [{ message: "请输入用户名", required: true, trigger: "blur" }],
        password: [{ message: "请输入密码", required: true, trigger: "blur" }],
      },
      redirect: "",
      schoolList: [
        {
          value: "选项1",
          label: "黄金糕",
        },
      ],
      schoolCode: "",
      ipUser: false,
      //titlename: "外文学术资源数据库",
      titlename: "登录",
      noipUser: false,
      tab2: true,
      code: "",
    };
  },
  created() {},
  mounted() {
    if (this.$route.query.redirect) {
      this.redirect = this.$route.query.redirect;
    }
    this.getIPUser();
    if (this.$route.query.asp) {
      this.titlename = "登录";
      // this.titlename = "文献服务平台";
      // this.tab2 = false;
    }
  },
  methods: {
    getIPUser() {
      this.$http({
        url: "/api/v1/plug/getIpUser",
        method: "GET",
      }).then(res => {
        if (res.code == 200) {
          if (res.data.userName) {
            // this.ruleForm.username = res.data.userName;
            // this.ruleForm.password = res.data.password;
            this.name = res.data.userName;
            this.pwd = res.data.password;
            this.noIP = res.data.remark;
            this.$http({
              url: "/api/v1/system/ipuser/user/state?userName=" + res.data.userName,
              method: "GET",
            }).then(res => {
              if (res.data != "符合条件" && res.data.indexOf("IP") == -1) {
                this.$message.error(res.data);
                return;
              } else {
                // 检查结果是否包含IP信息，如果包含则提取提示内容
                let warningMessage = "";
                if (res.data.indexOf("IP") !== -1) {
                  // 去掉"IP"相关内容，只保留提示信息
                  warningMessage = res.data.replace(/IP/gi, "").trim();
                  // 保存提示信息到localStorage
                  localStorage.setItem("ipWarning", warningMessage);
                } else {
                  // 如果没有IP信息，清空提示
                  localStorage.removeItem("ipWarning");
                }
                //在ip范围内 静默登录
                let postBody = {
                  username: this.name,
                  password: this.pwd,
                };
                // 点击顶部退出按钮不执行自动ip登录
                if (this.$route.query.word) {
                  return;
                }
                if (this.$route.query.ipFrom) {
                  this.ipUser = true;
                  return;
                }
                this.$http({
                  url: "/api/v1/login",
                  method: "POST",
                  data: postBody,
                }).then(res => {
                  if (res.code == 200) {
                    // this.$message.success("登录成功");
                    localStorage.setItem("userName", this.ruleForm.username);
                    this.$store.commit("getUserName", this.ruleForm.username);
                    localStorage.setItem("jyx_token", res.token);
                    if (this.$route.query.redirect) {
                      this.get_urlpath(res.token);
                      //浏览器插件回调
                    } else if (this.$route.query.redirectUrl) {
                      let redirectUrl = this.fullyDecodeURL(this.$route.query.redirectUrl);
                      if (redirectUrl.includes("urldomain=")) {
                        this.$router.go(-1);
                      } else {
                        this.$router.push({ path: "/articleSearch" });
                      }
                    } else {
                      this.$router.push({ path: "/articleSearch" });
                    }
                  }
                });
              }
            });
          } else {
            this.noIP = "校园用户,IP范围内使用"; //不在ip范围内
          }
        }
      });
    },
    //浏览器插件回调
    get_urlpath(token) {
      this.$http({
        url: "api/v1/user/info",
        method: "POST",
      }).then(res => {
        if (res.data.schoolName) {
          window.location.href = this.$route.query.redirect + `&token=${token}&name=${encodeURIComponent(this.ruleForm.username)}&schoolName=${encodeURIComponent(res.data.schoolName)}`;
        } else {
          window.location.href = this.$route.query.redirect + `&token=${token}&name=${encodeURIComponent(this.ruleForm.username)}`;
        }
      });
    },
    // 添加一个新方法来解析URL中的code值
    handleChangeTab(index) {
      this.tabIndex = index;
      if (index == 2) {
        this.getSchol();
      }
    },
    getSchol() {
      this.$http({
        url: "api/v1/cas/school/list",
        method: "get",
      }).then(res => {
        this.schoolList = res.data;
      });
    },
    // 统一跳转登录
    toCaseLogin() {
      if (!this.schoolCode) {
        this.$message.error("请选择学校");
        return;
      }
      this.$http({
        url: "/api/v1/system/ipuser/school/state?schoolName=" + this.schoolCode,
        method: "GET",
      }).then(res => {
        if (res.code == 200) {
          if (res.data == "该系统学校已停用") {
            this.$message.error("该学校已停用无法登录");
            return;
          }
          localStorage.setItem("schoolCode", this.schoolCode);
          this.schoolList.forEach(element => {
            if (element.code == this.schoolCode) {
              // location.href = element.url;
              if (element.url) {
                location.href = element.url;
              } else {
                location.href = `${urlSet.baseUrl}api/v1/sso/toAuthenticate?redirect=`;
              }
            }
          });
        }
      });
    },

    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$http({
            url: "/api/v1/system/ipuser/user/state?userName=" + this.ruleForm.username,
            method: "GET",
          }).then(res => {
            if (res.data == "该系统学校已停用") {
              this.$message.error("该学校已停用无法登录");
              return;
            }
            if (res.data.indexOf("联系") !== -1) {
              this.$message.error(res.data);
              return;
            }
            let postBody = {
              username: this.ruleForm.username,
              password: this.ruleForm.password,
            };
            this.$http({
              url: "/api/v1/login",
              method: "POST",
              data: postBody,
            }).then(res => {
              if (res.code == 200) {
                if (!this.$route.query.asp) {
                  this.$message.success("登录成功");
                }
                localStorage.setItem("userName", this.ruleForm.username);
                this.$store.commit("getUserName", this.ruleForm.username);
                localStorage.setItem("jyx_token", res.token);
                if (this.$route.query.redirect) {
                  //浏览器插件回调
                  if (this.$route.query.redirect.indexOf("?") != -1) {
                    this.get_urlpath(res.token);
                  } else {
                    //判断是否是从空白页面登录
                    if (this.$route.query.redirect.indexOf(".") != -1) {
                      // 特殊页面  https://pubmed.ncbi.nlm.nih.gov/28134237/  这个网站会把带过去的参数冲掉 参数前面要添加#
                      let str = this.$route.query.redirect;
                      if (str.charAt(str.length - 1) == "/") {
                        window.location.href = this.$route.query.redirect + `#?token=${res.token}&name=${this.ruleForm.username}`;
                      } else {
                        window.location.href = this.$route.query.redirect + `?token=${res.token}&name=${this.ruleForm.username}`;
                      }
                    } else {
                      // this.$router.go(-1);
                      window.location.href = `/articleSearch` + `?token=${res.token}&name=${this.ruleForm.username}`;
                    }
                  }
                } else if (this.$route.query.asp) {
                  this.getMineInfo();
                } else {
                  // 点击全文获取 跳转登录后 在回到原来页面
                  debugger;
                  if (this.$route.query.isback) {
                    this.$router.go(-1);
                  } else if (this.$route.query.redirectUrl) {
                    let redirectUrl = this.fullyDecodeURL(this.$route.query.redirectUrl);
                    // 尝试从多层嵌套的URL中提取最终的目标路径
                    let targetPath = this.extractTargetPath(redirectUrl);
                    if (targetPath) {
                      this.$router.push({ path: targetPath });
                    } else if (redirectUrl.includes("urldomain=")) {
                      this.$router.go(-1);
                    } else {
                      this.$router.push({ path: "/articleSearch" });
                    }
                  } else {
                    this.$router.push({ path: "/articleSearch" });
                  }
                }
              }
            });
          });
        } else {
          return false;
        }
      });
    },
    fullyDecodeURL(encodedUrl) {
      let decodedUrl = encodedUrl;
      let lastDecoded = "";

      // 循环解码直到没有变化或达到最大解码次数
      let maxDecodingAttempts = 10;
      let attempts = 0;

      while (decodedUrl !== lastDecoded && attempts < maxDecodingAttempts) {
        lastDecoded = decodedUrl;
        try {
          decodedUrl = decodeURIComponent(decodedUrl);
        } catch (e) {
          // 解码失败，保持当前值
          break;
        }
        attempts++;
      }

      return decodedUrl;
    },
    getMineInfo() {
      this.$http({
        url: "api/v1/user/info",
        method: "POST",
      }).then(res => {
        if (res.data.ipUser) {
          this.ipUser = true;
          return false;
          // this.$message.error("您当前不在学校IP范围内不可注册");
        } else {
          this.$message.success("登录成功");
          this.$router.push({ path: "/articleSearch" });
          window.open(`/asp/`, "_self");
        }
      });
    },
    // 从多层嵌套的URL中提取最终的目标路径
    extractTargetPath(url) {
      try {
        // 检查是否包含articleSearch
        if (url.includes("/articleSearch")) {
          // 提取articleSearch部分及其参数
          const articleSearchIndex = url.indexOf("/articleSearch");
          let path = url.substring(articleSearchIndex);
          // 移除可能的额外嵌套部分
          const nextRedirectIndex = path.indexOf("redirectUrl");
          if (nextRedirectIndex > -1) {
            path = path.substring(0, nextRedirectIndex);
          }
          return path.split("?")[0]; // 返回不带参数的路径
        }
        return null;
      } catch (e) {
        console.error("提取目标路径失败:", e);
        return null;
      }
    },
    toregister() {
      this.$http({
        url: "api/v1/tourist/check/allow",
        method: "GET",
      }).then(res => {
        if (res.data) {
          if (this.$route.query.asp) {
            this.$router.push({
              path: "/register?asp=true",
            });
          } else {
            this.$router.push({ path: "/register" });
          }
        } else {
          // this.noipUser = true;
          this.$message.error("您当前不在学校IP范围内不可注册");
        }
      });
    },
    topwd() {
      if (this.$route.query.asp) {
        this.$router.push({
          path: "/findpwd?asp=true",
        });
      } else {
        this.$router.push({ path: "/findpwd" });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  min-width: calc(100vw);
  min-height: calc(100vh);
  display: flex;
  align-items: center;
  justify-content: center;
  background: url("../../assets/images/bg.png") no-repeat;
  background-size: cover;
  .login-bottom {
    position: absolute;
    text-align: center;
    bottom: 20px;
    color: #fff;
    font-size: 14px;
  }
  .main {
    position: relative;
    border-radius: 0px;
    background: #ffffff;
    min-height: 390px;
    width: 450px;
    padding: 70px 25px 30px 25px;
    box-shadow: -6px 0px 12px 6px rgba(0, 0, 0, 0.1);
    h3 {
      text-align: center;
      margin-bottom: 35px;
      color: #2d8cf0;
      font-size: 22px;
    }
    .tips {
      position: absolute;
      top: 10px;
      left: 10px;
      font-size: 14px;
      color: #bcbcbc;
      i {
        margin-right: 5px;
      }
    }
    .ipTips {
      font-size: 14px;
      i {
        margin-right: 5px;
      }
    }
    .red {
      color: #fa0000 !important;
    }
  }
  .loginForm {
    padding: 0 40px;
    .el-select {
      width: 100%;
    }
    .el-button {
      width: 100%;
      margin-top: 20px;
    }
    .inputDiv {
      display: flex;
      align-items: center;
      border: 1px solid #dcdfe6;
      border-radius: 5px;
      position: relative;
      &::after {
        content: "";
        position: absolute;
        left: 43px;
        height: 23px;
        top: 50%;
        margin-top: -12px;
        width: 1px;
        display: inline-block;
        background: #2d8cf0;
      }

      ::v-deep .el-input {
        padding-left: 10px;
        .el-input__inner {
          border: none;
        }
      }
      img {
        width: 23px;
        height: 23px;
        margin-left: 10px;
        position: relative;
      }
    }
    .tab2-btn {
      margin: 20px 0px;
    }
  }
  .tab {
    padding: 0 70px;
    border-bottom: 1px solid #dcdfe6;
    padding-bottom: 20px;
    margin-bottom: 30px;
    ul {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    li {
      color: #666666;
      font-size: 18px;
      cursor: pointer;
      position: relative;
      margin: 0 20px;
    }
    .checked {
      color: #2d8cf0;
      &::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: -21px;
        height: 2px;
        width: 100%;
        background: #2d8cf0;
      }
    }
  }
  .userbtn {
    display: flex;
    width: 320px;
    margin: 0px auto;
    font-size: 14px;
    color: #666666;
    span {
      color: #2d8cf0;
      margin-left: 5px;
      cursor: pointer;
      text-decoration: underline;
    }
    .register {
      flex: 1;
    }
    .pwd {
      flex: 1;
      text-align: right;
    }
  }
}
</style>
